import styled from 'styled-components';
import { DotListContainer } from '../Structure/DotList';
export const ListItemContainer = styled.div `
    display: flex;
    align-items: center;
    padding: 1rem;
    cursor: pointer;

    :hover {
        background-color: ${(props) => props.theme.colors.actionHover};
    }

    :focus {
        background-color: ${(props) => props.theme.colors.actionFocus};
    }

    :active {
        background-color: ${(props) => props.theme.colors.actionActive};
    }
`;
export const ListItemImageContainer = styled.div `
    margin-right: 1rem;
`;
export const ListItemInfoContainer = styled.div `
    flex: 1;
`;
export const ListItemDescriptionDotListContainer = styled(DotListContainer) `
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
    margin-top: 0.5rem;
`;
//# sourceMappingURL=ListItem.styles.js.map